<app-table
    class="hidden md:block"
    [loading]="loading()"
    [pageSize]="activeState().pageSize()"
    [currentPage]="activeState().page()"
    [totalItems]="total()"
    (pageChange)="activeState().page.set($event)"
    (pageSizeChange)="activeState().pageSize.set($event)"
>
    <app-table-head>
        <app-table-header width="90px"></app-table-header>
        <app-table-header
            width="400px"
            [filterable]="true"
            (sortOrderChanged)="sortChange.emit({ column: 'subject', order: $event })"
            >{{ 'request-tables.subject' | translate }}</app-table-header
        >
        <app-table-header
            width="180px"
            [filterable]="true"
            (sortOrderChanged)="sortChange.emit({ column: 'created_at', order: $event })"
            >{{ 'request-tables.created' | translate }}</app-table-header
        >
        <app-table-header width="180px">{{ 'request-tables.status' | translate }}</app-table-header>
    </app-table-head>
    @for (request of tasks(); track $index) {
        <app-table-row [routerLink]="['/', 'request', request.id]" [pillColor]="statusPillColorMap[request.status]">
            <app-table-cell width="90px">IRO-{{ request.displayId }}</app-table-cell>
            <app-table-cell width="400px">{{ request.subject }}</app-table-cell>
            <app-table-cell width="180px">
                <app-table-date-cell [date]="request.createdAt"></app-table-date-cell>
            </app-table-cell>
            <app-table-cell width="180px">
                <app-requests-status-pill [status]="request.status"></app-requests-status-pill>
            </app-table-cell>
        </app-table-row>
    }
</app-table>

<app-mobile-table
    class="md:hidden"
    [loading]="loading()"
    [totalItems]="total()"
    [pageSize]="activeState().pageSize()"
    [currentPage]="activeState().page()"
    (pageChange)="activeState().page.set($event)"
    (pageSizeChange)="activeState().pageSize.set($event)"
>
    @for (request of tasks(); track $index) {
        <app-mobile-table-card
            [routerLink]="['/', 'request', request.id]"
            [accentColor]="statusPillColorMap[request.status]"
        >
            <span class="text-base text-shui-text-strong flex items-center font-semibold text-wrap"
                >IRO-{{ request.displayId }}: {{ request.subject }}</span
            >
            <div class="flex flex-col gap-4">
                <app-mobile-row-field label="request-tables.status">
                    {{ 'status.' + request.status | translate }}
                </app-mobile-row-field>
                <app-mobile-row-field label="request-tables.created">
                    <app-table-date-cell [date]="request.createdAt"></app-table-date-cell>
                </app-mobile-row-field>
            </div>
        </app-mobile-table-card>
    }
</app-mobile-table>
